import { createReducer } from '@reduxjs/toolkit';
import _set from 'lodash/set';
import { ACTIVE_KEY } from '../utilities/constants';
import adjustmentToggled from '../actions/adjustmentToggled';
import resetAllToggles from '../actions/resetAllToggles';
import { ingestionBegan } from './StructuredAnalysisSlice';
import { clearAllProjectData } from '../actions/clearAllProjectData';

const initialState = {};
const adjustmentTogglesByDocument = createReducer(initialState, {
  [adjustmentToggled]: (stateNode, action) => {
    const { documentCode, adjustmentType, adjustmentName, active } =
      action.payload;

    _set(
      stateNode,
      [documentCode, adjustmentType, adjustmentName, ACTIVE_KEY],
      active
    );
  },

  [resetAllToggles]: (_state) => initialState,
  [ingestionBegan]: (_state) => initialState,
  [clearAllProjectData]: (_state) => initialState,
});

export default adjustmentTogglesByDocument;
